import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { Button } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";

import { useBlockPlanTrialDowngrade } from "./hooks/useBlockPlanTrialDowngrade";
import { Loader } from "./Loader";
import { UpgradePlanModalBody } from "./UpgradePlanModalBody";
import { UpgradePlanModalFooter } from "./UpgradePlanModalFooter";
import { UpgradePlanModalHeader } from "./UpgradePlanModalHeader";

const i18nRoot = "pricing_plans.upgrade_modal.block_plan_trial_downgrade";

export const BlockPlanTrialDowngrade = () => {
  const {
    isLoading,
    planTrialEndDateFormatted,
    planTrialDaysLeft,
    handleContactSupportOnClick,
  } = useBlockPlanTrialDowngrade();

  if (isLoading) {
    return <Loader title={t("pricing_plans.upgrade_modal.loading.loading")} />;
  }

  return (
    <>
      <UpgradePlanModalHeader title={t([i18nRoot, "title"])}>
        <Modal.Title>{t([i18nRoot, "title"])}</Modal.Title>
      </UpgradePlanModalHeader>
      <UpgradePlanModalBody>
        <div className="flex flex-col items-center gap-4">
          <Typography.BodyMd>
            {t([i18nRoot, "description"], {
              days: planTrialDaysLeft,
              date: planTrialEndDateFormatted,
            })}
          </Typography.BodyMd>
          <Typography.BodyMd>{t([i18nRoot, "explanation"])}</Typography.BodyMd>
        </div>
      </UpgradePlanModalBody>
      <UpgradePlanModalFooter
        primaryAction={{
          label: t([i18nRoot, "button"]),
          onClick: handleContactSupportOnClick,
        }}
      >
        <div className="flex flex-row justify-end">
          <Button variant="primary" onClick={handleContactSupportOnClick}>
            {t([i18nRoot, "button"])}
          </Button>
        </div>
      </UpgradePlanModalFooter>
    </>
  );
};
